///? Default IMPORTS

import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

///? Service IMPORTS

import {
  getOrderIDScanThunk,
  setBoxIDScanThunk,
} from "../../redux/ScannerRedux/Action.js";

import { addRackThunk } from "../../redux/RackRedux/Action.js";
import {
  updateTOMedThunk,
  fetchCheckerTOThunk,
} from "../../redux/TOThunks/Action.js";
import {
  generateAwbNbrStickerThunk,
  generatePaymentPendingPdfThunk,
  printPdfThunk,
  createOrderClickPostThunk,
  callSrCreateOrderThunk,
} from "../../redux/dispatchRedux/Action";

import {
  generateInvoicePdfThunk,
  checkUrlThunk,
} from "../../redux/newCheckerRedux/Action.js";

///? Component & Styling IMPORTS

// import Scanner from "./Scanner.jsx";
// import Quagga from "quagga";
import { Base64func } from "../../components/Base64Func/Base64func";
import { Alert, Drawer, message, Modal, Result } from "antd";
import { selectPrinterByDesk } from "../../components/helper/deskData";
import { CURRENT_BOX, REGEX, warehouseId } from "../../constants/index.js";
import ReactQRBarcodeScanner from "./newScan/scan.js";

const toBoxCheck = /^[a-zA-Z0-9\s]*$/;

class BarcodeScanner extends Component {
  state = {
    camera: this.props.camera,
    result: null,
    showScannerScreen: this.props.scan,
    loading: false,
    pickerUpdateModalShow: false,
    alreadyPrinted: false,
    locationKeys: null,
    currUrl: null,
    alreadyPrintedModalError: false,
  };

  componentDidMount = () => {
    this.setState({ currUrl: window.location.pathname });
  };

  onDetected = (value) => {
    if (value && REGEX.SPECIAL_CHAR.test(value)) {
      message.error(
        "Invalid barcode detected. Please scan a valid barcode.",
        2
      );
      this.setState({ result: null });
    } else {
      this.setState({ result: value });
    }
  };

  pickerUpdateFunc = () => {
    this.setState({ pickerUpdateModalShow: true });
  };

  generateAwbNbrSticker = (params) => {
    this.props.generateAwbNbrStickerThunk(params).then(() => {
      message.destroy();
      if (this.props.dispatchDetails.awbStickerError) {
        message.error(this.props.dispatchDetails.awbStickerError, 2);
        this.setState({ showScannerScreen: false, camera: false });
        this.setState({ loading: false });
        this.props.getBoxId(null);
        // Quagga.stop();
      } else if (this.props.dispatchDetails.awbStickerDetails) {
        message.loading("Printing...", 0);
        let printerData = {
          printerDetails: {
            printerId: selectPrinterByDesk(
              this.props.checkerDetails?.deskDetails?.deskDetailsList,
              this.props.deskNumber
            ),
            contentType: "pdf_uri",
            content: this.props.dispatchDetails.awbStickerDetails,
            title:
              this.props.scannerData.scannedOrderIDOrderDetailsSuccess.orderId +
              " - Sticker",
            source: "Dispatch",
          },
          history: this.props.history,
        };
        this.startPrinting(printerData);
      } else {
        message.error("No URL found", 2);
        this.setState({ showScannerScreen: false, camera: false });
        this.setState({ loading: false });
        this.props.getBoxId(null);
        // Quagga.stop();
      }
    });
  };

  generatePaymentPendingPdf = (params) => {
    this.props.generatePaymentPendingPdfThunk(params).then(() => {
      message.destroy();
      if (this.props.dispatchDetails.paymentPendingError) {
        message.error(this.props.dispatchDetails.paymentPendingError, 2);
        this.setState({ showScannerScreen: false, camera: false });
        this.setState({ loading: false });
        this.props.getBoxId(null);
        // Quagga.stop();
      } else if (this.props.dispatchDetails.paymentPendingDetails) {
        message.loading("Printing...", 0);
        let printerData = {
          printerDetails: {
            printerId: selectPrinterByDesk(
              this.props.checkerDetails?.deskDetails?.deskDetailsList,
              this.props.deskNumber
            ),
            contentType: "pdf_uri",
            content: this.props.dispatchDetails.paymentPendingDetails,
            title:
              this.props.scannerData.scannedOrderIDOrderDetailsSuccess.orderId +
              " - Sticker",
            source: "Dispatch",
          },
          history: this.props.history,
        };
        this.startPrinting(printerData);
      } else {
        message.error("No URL found", 2);
        this.setState({ showScannerScreen: false, camera: false });
        this.setState({ loading: false });
        this.props.getBoxId(null);
        // Quagga.stop();
      }
    });
  };

  startPrinting = (printerData) => {
    this.props.printPdfThunk(printerData).then(() => {
      message.destroy();
      message.error(this.props.checkerDetails.invoiceDetailsError, 2);
      this.setState({ showScannerScreen: false, camera: false });
      this.setState({ loading: false });
      this.props.getBoxId(null);
      // Quagga.stop();
      if (this.props.dispatchDetails.printerError) {
        message.error(this.props.dispatchDetails.printerError, 2);
      } else if (this.props.dispatchDetails.printerDetails) {
        message.success("Done", 1);
      } else {
        message.error("Unknown error", 2);
      }
    });
  };

  printInvoice = (orderId) => {
    if (!orderId) {
      message.error("Please scan again to get the order id", 2);
      this.setState({ showScannerScreen: false, camera: false });
      this.setState({ loading: false });
      this.props.getBoxId(null);
      // Quagga.stop();
    } else if (!this.props.deskNumber) {
      message.error("Please select a desk to print the invoice", 2);
      this.setState({ showScannerScreen: false, camera: false });
      this.setState({ loading: false });
      this.props.getBoxId(null);
      // Quagga.stop();
    } else {
      message.loading("Printing...", 0);
      let data = {
        access_token: this.props.access_token,
        warehouseId: warehouseId,
        orderIds: [orderId],
        history: this.props.history,
        newAlgo: this.props.scannerData?.scannedOrderIDOrderDetailsSuccess
          ?.newAlgo,
      };
      this.props.generateInvoicePdfThunk(data).then(() => {
        if (this.props.checkerDetails.invoiceDetailsError) {
          message.destroy();
          // message.error(this.props.checkerDetails.invoiceDetailsError, 2);
          this.setState({
            showScannerScreen: false,
            camera: false,
            alreadyPrintedModalError: true,
          });
          this.setState({ loading: false });
          this.props.getBoxId(null);
          // Quagga.stop();
        } else if (this.props.checkerDetails.invoiceDetails?.OrderPdfLink) {
          this.props
            .checkUrlThunk(
              this.props.checkerDetails.invoiceDetails?.OrderPdfLink
            )
            .then(() => {
              if (this.props.checkerDetails.urlFailure) {
                this.setState({ showScannerScreen: false, camera: false });

                message.error(
                  "There seems to be an issue with this order, Please report to Tech"
                );
              } else {
                let printerData = {
                  printerDetails: {
                    printerId: selectPrinterByDesk(
                      this.props.history?.location?.state?.deskData
                        ?.deskDetailsList
                        ? this.props.history?.location?.state?.deskData
                            ?.deskDetailsList
                        : this.props.checkerDetails?.deskDetails
                            ?.deskDetailsList,
                      this.props.deskNumber
                    ),
                    contentType: "pdf_uri",
                    content: this.props.checkerDetails.invoiceDetails
                      .OrderPdfLink,
                    title: orderId + " - Invoice",
                    source: "Checker",
                  },
                  history: this.props.history,
                };
                this.startPrinting(printerData);
              }
            });
        } else {
          message.destroy();
          message.error("No url found", 2);
          this.setState({ showScannerScreen: false, camera: false });
          this.setState({ loading: false });
          this.props.getBoxId(null);
          // Quagga.stop();
        }
      });
    }
  };

  pickerProcessFunc = ({
    isChecker,
    isPacker,
    isDispatch,
    isPicker,
    isCheckerInvoice,
  }) => {
    this.setState({ loading: true });

    let data = {
      access_token: this.props.access_token,
      history: this.props.history,
      boxNumber: this.state.result,
    };

    this.props.getOrderIDScanThunk(data).then(() => {
      if (this.props.scannerData.scannedOrderIDOrderError) {
        message.error(this.props.scannerData.scannedOrderIDOrderError, 2);
        this.setState({
          showScannerScreen: false,
          camera: false,
          loading: false,
          pickerUpdateModalShow: false,
        });
        this.props.getBoxId(null);
        // Quagga.stop();
      } else if (
        this.props.scannerData?.scannedOrderIDOrderDetailsSuccess?.orderId
      ) {
        message.success(
          `Order ID. ${this.props.scannerData.scannedOrderIDOrderDetailsSuccess.orderId} assigned`,
          2
        );

        if (isChecker) {
          this.props.history.push(
            `/checker-order/orderId=${Base64func(
              this.props.scannerData.scannedOrderIDOrderDetailsSuccess.orderId,
              "encode"
            )}`
          );
        } else if (isPacker) {
          this.props.history.push(
            `/packer-process/orderId=${Base64func(
              this.props.scannerData.scannedOrderIDOrderDetailsSuccess.orderId,
              "encode"
            )}`
          );
        } else if (isDispatch) {
          if (
            this.props.scannerData.scannedOrderIDOrderDetailsSuccess
              ?.packageDetailsTracking?.awbNoPrinted &&
            !this.state.alreadyPrinted
          ) {
            this.setState({ alreadyPrintedModal: true });
          } else if (!this.props.deskNumber) {
            message.error("Please select desk to print the sticker", 2);
          } else {
            message.loading("Fetching Details...", 0);
            let params = {
              access_token: this.props.access_token,
              orderId: this.props.scannerData.scannedOrderIDOrderDetailsSuccess
                .orderId,
              history: this.props.history,
            };
            if (
              this.props.scannerData.scannedOrderIDOrderDetailsSuccess?.awbNo
            ) {
              this.generateAwbNbrSticker(params);
            } else if (
              !this.props.scannerData.scannedOrderIDOrderDetailsSuccess
                ?.awbNo &&
              this.props.scannerData.scannedOrderIDOrderDetailsSuccess
                ?.orderStatus?.serialId === 66
            ) {
              message.loading("Please wait...", 0);
              let cpSrData = {
                access_token: this.props.access_token,
                createOrderReq: {
                  orderId: this.props.scannerData
                    .scannedOrderIDOrderDetailsSuccess?.orderId,
                  transactionId: this.props.scannerData
                    .scannedOrderIDOrderDetailsSuccess?.orderId,
                  invoiceNo: this.props.scannerData
                    .scannedOrderIDOrderDetailsSuccess?.packageDetailsTracking
                    ?.invoiceNumber,
                  invoiceDate: this.props.scannerData
                    .scannedOrderIDOrderDetailsSuccess?.packageDetailsTracking
                    ?.invoiceDate,
                  courierPartnerId: this.props.scannerData
                    .scannedOrderIDOrderDetailsSuccess?.packageDetailsTracking
                    ?.courierPartnerId,
                  courierPartner: this.props.scannerData
                    .scannedOrderIDOrderDetailsSuccess?.packageDetailsTracking
                    ?.courierPartnerAccountCode,
                  courierPartnerName: this.props.scannerData
                    .scannedOrderIDOrderDetailsSuccess?.packageDetailsTracking
                    ?.courierPartnerAccountCode,
                },
              };
              if (
                this.props.scannerData.scannedOrderIDOrderDetailsSuccess
                  ?.packageDetailsTracking?.shippingPartnerId === 255
              ) {
                this.props.createOrderClickPostThunk(cpSrData).then(() => {
                  message.destroy();
                  if (this.props.dispatchDetails?.cpError) {
                    message.error(this.props.dispatchDetails?.cpError, 2);
                    this.setState({ showScannerScreen: false, camera: false });
                    this.setState({ loading: false });
                    this.props.getBoxId(null);
                    // Quagga.stop();
                  } else if (
                    this.props.dispatchDetails?.cpSuccess?.meta?.message ===
                    "We are processing your order"
                  ) {
                    message.error("Please try again after 5 mins");
                    this.setState({ autoScanBoxNumber: "" });
                    this.setState({ showScannerScreen: false, camera: false });
                    this.setState({ loading: false });
                    this.props.getBoxId(null);
                    // Quagga.stop();
                  } else {
                    this.pickerProcessFunc({ isDispatch: true });
                  }
                });
              } else if (
                this.props.scannerData.scannedOrderIDOrderDetailsSuccess
                  ?.packageDetailsTracking?.shippingPartnerId === 256
              ) {
                this.props.callSrCreateOrderThunk(cpSrData).then(() => {
                  message.destroy();
                  if (this.props.dispatchDetails?.srError) {
                    message.error(this.props.dispatchDetails?.srError, 2);
                    this.setState({ showScannerScreen: false, camera: false });
                    this.setState({ loading: false });
                    this.props.getBoxId(null);
                    // Quagga.stop();
                  } else {
                    this.pickerProcessFunc({ isDispatch: true });
                  }
                });
              } else {
                message.error("No shipping partner found", 2);
                this.setState({ showScannerScreen: false, camera: false });
                this.setState({ loading: false });
                this.props.getBoxId(null);
                // Quagga.stop();
              }
            } else if (
              this.props.scannerData.scannedOrderIDOrderDetailsSuccess
                ?.orderStatus?.serialId === 58
            ) {
              this.generatePaymentPendingPdf(params);
            } else {
              message.error(
                "AWB number not generated. Please try again after some time."
              );
              this.setState({ showScannerScreen: false, camera: false });
              this.setState({ loading: false });
              this.props.getBoxId(null);
              // Quagga.stop();
            }
          }
        } else if (isPicker) {
          this.props.history.push(
            `/picker-order/orderId=${Base64func(
              this.props.scannerData.scannedOrderIDOrderDetailsSuccess.orderId,
              "encode"
            )}`
          );
        } else if (isCheckerInvoice) {
          this.printInvoice(
            this.props.scannerData.scannedOrderIDOrderDetailsSuccess.orderId
          );
        }
      }
    });
  };

  pickerFunc = () => {
    this.setState({ loading: true });

    let data = {
      access_token: this.props.access_token,
      history: this.props.history,
      orderId: this.props.orderId,
      boxNumber: this.state.result,
      isSetBox: this.props.boxUpdate ? this.props.boxUpdate : false,
    };

    this.props.setBoxIDScanThunk(data).then(() => {
      if (this.props.scannerData.scannedBoxIDOrderError) {
        message.error(this.props.scannerData.scannedBoxIDOrderError, 2);

        this.setState({ showScannerScreen: false, camera: false });
        this.setState({ loading: false });
        this.props.getBoxId(null);

        // Quagga.stop();
      } else if (this.props.scannerData.scannedBoxIDOrderDetailsSuccess) {
        message.success(`Box No. ${this.state.result} assigned`, 2);

        this.props.history.push(
          `/picker-order/orderId=${Base64func(this.props.orderId, "encode")}`
        );
      }
    });
  };

  TOPickerSamePagefunc = () => {
    // let data = {
    //   access_token: this.props.access_token,
    //   history: this.props.history,
    //   toNumber: this.props.orderId,
    //   boxNumber: this.state.result,
    // };

    if (toBoxCheck.test(this.state.result)) {
      if (this.state.result !== this.props.boxNumber) {
        // Quagga.stop();
        message.success(`Box No. ${this.state.result} assigned`, 2);
        this.TOPickerSamePageSuccess();
      } else {
        this.props.getBoxId(null);
        // Quagga.stop();
        this.setState({ showScannerScreen: false, camera: false });
        this.setState({ loading: false });

        message.error("Same box being scanned. Please scan another box");
      }
    } else {
      this.props.getBoxId(null);
      // Quagga.stop();
      this.setState({ showScannerScreen: false, camera: false });
      this.setState({ loading: false });

      message.error("Enter valid box number!");
    }
  };

  TOPickerSamePageSuccess = () => {
    this.setState({
      showScannerScreen: false,
    });
    this.props.getBoxId(null);
    // Quagga.stop();
    this.props.updateCurrentBox(this.state.result);
  };

  TOPickerfunc = () => {
    // ------------ Assigning box function for TOPicker

    this.setState({ loading: true });

    let data = {
      access_token: this.props.access_token,
      history: this.props.history,
      toNumber: this.props.orderId,
      boxNumber: this.state.result,
    };

    if (toBoxCheck.test(this.state.result)) {
      if (
        this.props.currTOData?.boxDetails &&
        this.props.currTOData?.boxDetails.length > 0
      ) {
        if (this.props.currTOData?.boxDetails.includes(this.state.result)) {
          this.ToPickerSuccessFunc();
        } else {
          message.error("This box does not belong to this Transfer Order");
          this.props.updateShowScannerScreen(false);
        }
      } else {
        this.ToPickerSuccessFunc();
      }
    } else {
      message.error("Enter valid box number!", 2);
      this.setState({ showScannerScreen: false, camera: false });
      this.setState({ loading: false });
      this.props.getBoxId(null);
      // Quagga.stop();
    }

    // this.props.updateTOMedThunk(data).then(() => {
    //   if (this.props.TOReducer?.TOPickerUpdateMedErr) {
    //     message.error(this.props.TOReducer?.TOPickerUpdateMedErr, 2);
    //     this.setState({ showScannerScreen: false, camera: false });
    //     this.setState({ loading: false });
    //     this.props.getBoxId(null);
    //  // Quagga.stop();
    //   } else if (this.props.TOReducer?.TOPickerUpdateMedData) {
    //     message.success(`Box No. ${this.state.result} assigned`, 2);
    //     this.props.history.push(
    //       `/to-picker-order/TOID=${Base64func(this.props.orderId, "encode")}`
    //     );
    //   }
    // });
  };

  ToPickerSuccessFunc = () => {
    this.props.history.push(
      `/to-picker-order/${Base64func(this.props.orderId, "encode")}`
    );

    localStorage.setItem(CURRENT_BOX, JSON.stringify(this.state.result));
  };

  TOCheckerBoxProcessFunc = () => {
    // ------------ Box verify before medicine check verification

    let { boxData } = this.props;
    let currBox = [];

    boxData?.filter((k) =>
      k.boxNumber === this.state.result ? currBox.push(k) : null
    );

    if (toBoxCheck.test(this.state.result)) {
      if (currBox[0]?.boxNumber === this.state.result) {
        if (currBox[0]?.checked) {
          this.props.getBoxId(false);
          // Quagga.stop();
          message.error("Box already verified", 2);
        } else {
          // Quagga.stop();
          this.props.history.push(
            `/to-checker-order/${Base64func(
              this.props.orderId,
              "encode"
            )}/${Base64func(this.state.result, "encode")}`
          );
        }
      } else {
        this.props.getBoxId(false);
        // Quagga.stop();
        message.warning("No matching box found for current TO");
      }
    } else {
      this.props.getBoxId(false);
      // Quagga.stop();
      message.warning("Enter valid box number!");
    }
  };

  TOCheckerfunc = () => {
    // ------------ Assigning box function for TOChecker

    this.setState({ loading: true });

    let data = {
      access_token: this.props.access_token,
      history: this.props.history,
      boxNumber: this.state.result,
    };

    if (toBoxCheck.test(this.state.result)) {
      this.props.fetchCheckerTOThunk(data).then(() => {
        if (this.props.TOReducer?.TOCheckerOrderErr) {
          message.error(this.props.TOReducer?.TOCheckerOrderErr, 2);
          this.setState({ showScannerScreen: false, camera: false });
          this.setState({ loading: false });
          this.props.getBoxId(null);
          // Quagga.stop();
        } else if (this.props.TOReducer?.TOCheckerOrderData?.toNumber) {
          message.success(`Box No. ${this.state.result} Scanned`, 2);
          this.props.history.push(
            `/to-checker-order-process/${Base64func(
              `${this.props.TOReducer?.TOCheckerOrderData?.toNumber}-${this.state.result}`,
              "encode"
            )}`
          );
        }
      });
    } else {
      message.error("Enter valid box number!", 2);
      this.setState({ showScannerScreen: false, camera: false });
      this.setState({ loading: false });
      this.props.getBoxId(null);
      // Quagga.stop();
    }
  };

  defaultFunc = (value) => {
    this.setState({ loading: true });

    let data = {
      access_token: this.props.access_token,
      history: this.props.history,
      orderId: this.props.orderId,
      boxNumber: this.state.result,
      isSetBox: value
        ? true
        : this.props.boxUpdate
        ? this.props.boxUpdate
        : false,
    };

    this.props.setBoxIDScanThunk(data).then(() => {
      if (this.props.scannerData.scannedBoxIDOrderError) {
        message.error(this.props.scannerData.scannedBoxIDOrderError, 2);
        this.setState({ showScannerScreen: false, camera: false });
        this.setState({ loading: false });
        this.props.getBoxId(null);

        // Quagga.stop();
      } else if (this.props.scannerData.scannedBoxIDOrderDetailsSuccess) {
        message.success(`Box No. ${this.state.result} assigned`, 2);

        setTimeout(() => {
          this.props.getBoxId(this.state.result);
          this.setState({ showScannerScreen: false });
        }, 1000);
      }
    });
  };

  missingRackFunc = () => {
    this.setState({ loading: true });

    let data = {
      access_token: this.props.access_token,
      history: this.props.history,
      orderId: this.props.orderId,
      rackNumber: this.state.result,
    };

    this.props.addRackThunk(data).then(() => {
      if (this.props.rackData.AddRackError) {
        message.error(this.props.rackData.AddRackError, 2);
        this.setState({ showScannerScreen: false, camera: false });
        this.setState({ loading: false });
        this.props.getBoxId(null);
        // Quagga.stop();
      } else {
        message.success(
          `Rack No. ${this.state.result} assigned to OrderId : ${this.props.orderId}`,
          2
        );

        setTimeout(() => {
          this.props.history.push(
            `/MissingZone/orderId=${Base64func(
              this.props.orderId,
              "encode"
            )}/rackNumber=${Base64func(this.state.result, "encode")}`
          );
        }, 1000);
      }
    });
  };

  updateCheckerPickingFunc = () => {
    if (
      this.props.boxId?.toString()?.trim() ==
      this.state.result?.toString()?.trim()
    ) {
      this.props.history.push(
        `/picker-order/orderId=${Base64func(this.props.orderId, "encode")}`
      );
    } else {
      if (this.props.orderData?.checkerName) {
        message.error("Wrong Order ID, Please pick right box", 2);

        this.setState({
          showScannerScreen: false,
          camera: false,
          loading: false,
          pickerUpdateModalShow: false,
        });

        this.props.getBoxId(null);

        // Quagga.stop();
      } else {
        this.defaultFunc(true);
      }
    }
  };

  missingMedRackFunc = () => {
    if (
      this.props.boxId?.toString()?.trim() ===
      this.state.result?.toString()?.trim()
    ) {
      this.setState({
        showScannerScreen: false,
        camera: false,
        loading: false,
        pickerUpdateModalShow: false,
      });
      this.props.getBoxId(this.state.result);

      // Quagga.stop();
    } else {
      message.error("Wrong Order ID, Please pick right box", 2);

      this.setState({
        showScannerScreen: false,
        camera: false,
        loading: false,
        pickerUpdateModalShow: false,
      });

      this.props.getBoxId(null);

      // Quagga.stop();
    }
  };

  toBinScanCall = () => {
    this.props.confirmCall(this.state.result?.toString()?.trim(), true);
    message.success(`Rack updated to ${this.state.result}`);
    this.setState({
      showScannerScreen: false,
      camera: false,
      loading: false,
      pickerUpdateModalShow: false,
    });
    this.props.getBoxId(null);
    // Quagga.stop();
  };

  multiContainerScan = () => {
    this.props.confirmCall(this.state.result?.toString()?.trim());
    this.setState({
      showScannerScreen: false,
      camera: false,
      loading: false,
      pickerUpdateModalShow: false,
    });
    this.props.getBoxId(null);
    // Quagga.stop();
  };

  multiContainerScan = () => {
    this.props.confirmCall(this.state.result?.toString()?.trim());
    this.setState({
      showScannerScreen: false,
      camera: false,
      loading: false,
      pickerUpdateModalShow: false,
    });
    this.props.getBoxId(null);
    // Quagga.stop();
  };

  scanRedirect = () => {
    // Quagga.stop();

    // if (
    //   navigator.mediaDevices &&
    //   typeof navigator.mediaDevices.getUserMedia === "function"
    // ) {
    //   navigator.getUserMedia(
    //     { audio: false, video: true },
    //     function (stream) {
    //       var track = stream.getTracks()[0];
    //       track.stop();
    //     },
    //     function (error) {
    //       console.log("getUserMedia() error", error);
    //     }
    //   );
    // }

    switch (this.props.redirect) {
      case "pickerUpdate":
        // this.pickerUpdateFunc();
        this.pickerProcessFunc({ isPicker: true });

        break;

      case "picker":
        this.pickerFunc();

        break;

      case "to-picker":
        this.TOPickerfunc();
        break;

      case "to-checker":
        this.TOCheckerfunc();
        break;

      case "to-checker-box-process":
        this.TOCheckerBoxProcessFunc();
        break;

      case "to-picker-same-page":
        this.TOPickerSamePagefunc();
        break;

      case "checker":
        this.pickerProcessFunc({ isChecker: true });
        break;

      case "missing":
        this.missingRackFunc();
        break;

      case "missingDashRack":
        this.missingMedRackFunc();
        break;

      case "packerProcess":
        this.pickerProcessFunc({ isPacker: true });
        break;

      case "dispatch":
        this.pickerProcessFunc({ isDispatch: true });
        break;

      case "updateCheckerPick":
        this.updateCheckerPickingFunc();
        break;

      case "checkerInvoice":
        this.pickerProcessFunc({ isCheckerInvoice: true });
        break;

      case "to-putaway-item":
        this.toBinScanCall();
        break;

      case "to-bin-picker-scan":
        this.toBinScanCall(true);
        break;

      case "multi_scan":
        this.multiContainerScan(true);
        break;

      case "packslip":
        this.props.printPackSlip?.({ boxNumber: this.state.result });
        // Quagga.stop();
        break;
      default:
        this.defaultFunc();
    }
  };

  render() {
    this.props.history.listen((location) => {
      if (this.props.history.action === "PUSH") {
        this.setState({ locationKeys: [location.key] });
      }

      if (this.props.history.action === "POP") {
        this.props.history.push(this.state.currUrl);
        // Handle back event
        this.setState({
          showScannerScreen: false,
          camera: false,
          loading: false,
          pickerUpdateModalShow: false,
        });

        this.props.getBoxId(null);

        // Quagga.stop();
      }
    });

    return (
      <div>
        <Drawer
          title="Scan the Barcode"
          placement="right"
          className="BarcodeDrawer"
          closable={this.props.closable ?? false}
          maskClosable={this.props.closable ?? false}
          onClose={() => {
            if (this.props.closable) {
              this.setState({ showScannerScreen: false, camera: false });
              this.setState({ loading: false });
              this.props.getBoxId(null);
              // Quagga.stop();
            }
          }}
          open={this.state.showScannerScreen}
        >
          <div>
            {/* {this.state.result && (
              <Alert
                message={`${
                  this.props.redirect === "missing" ? "RACK ID" : "BOX ID"
                } : ${this.state.result}`}
                type={
                  this.props.isRackSearch
                    ? "success"
                    : toBoxCheck.test(this.state.result)
                    ? "success"
                    : "error"
                }
                showIcon
                style={{ marginBottom: "1em" }}
              />
            )} */}

            <div className="barcodeContainer">
              {/* {this.state.camera && (
                <Scanner onDetected={(value) => this.onDetected(value)} />
              )} */}
              {this.props.scan && (
                <ReactQRBarcodeScanner onDetected={this.onDetected} />
              )}
            </div>

            <button
              className="bbtn submitBtn"
              style={{ marginTop: "1em" }}
              onClick={this.scanRedirect}
              disabled={
                !this.state.result ||
                this.state.loading ||
                this.props.isLoading ||
                (this.props.isRackSearch
                  ? !this.state.result
                  : !toBoxCheck.test(this.state.result))
              }
            >
              Submit
            </button>
          </div>
        </Drawer>

        <Modal
          title={`Continue Picking Box ID : ${this.state.result}?`}
          open={this.state.pickerUpdateModalShow}
          // centered
          onOk={this.pickerProcessFunc}
          onCancel={() => this.setState({ pickerUpdateModalShow: false })}
        >
          <Alert
            message="This process can't be reversed!"
            type="warning"
            showIcon
          />
        </Modal>

        <Modal
          title={`Do you want to print again?`}
          open={this.state.alreadyPrintedModal}
          // centered
          onOk={() =>
            this.setState(
              { alreadyPrintedModal: false, alreadyPrinted: true },
              () => {
                this.pickerProcessFunc({ isDispatch: true });
              }
            )
          }
          onCancel={() => this.setState({ alreadyPrintedModal: false })}
        >
          <Alert message="Sticker already printed" type="warning" showIcon />
        </Modal>

        <Modal
          title={``}
          footer={null}
          open={this.state.alreadyPrintedModalError}
          maskClosable={false}
          centered
          onCancel={() => this.setState({ alreadyPrintedModalError: false })}
        >
          <Result
            status="warning"
            title="Error Occured"
            extra={<p>{this.props.checkerDetails.invoiceDetailsError}</p>}
          />
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
  scannerData: state.scannerReducer,
  rackData: state.rackReducer,
  dispatchDetails: state.dispatchReducer,
  isLoading: state.LoaderReducer?.isLoading,
  checkerDetails: state.newCheckerOrderReducer,
  deskNumber: state.statusReducer?.deskNumber,
  TOReducer: state.TOReducer,
});

export default withRouter(
  connect(mapStateToProps, {
    getOrderIDScanThunk,
    setBoxIDScanThunk,
    addRackThunk,
    generateAwbNbrStickerThunk,
    generatePaymentPendingPdfThunk,
    printPdfThunk,
    createOrderClickPostThunk,
    callSrCreateOrderThunk,
    generateInvoicePdfThunk,
    checkUrlThunk,
    updateTOMedThunk,
    fetchCheckerTOThunk,
  })(BarcodeScanner)
);
